import styled from "styled-components";

const DefaultBox = styled.div<{headerArenasStyleIsMenu?: boolean;}>`
  position: absolute;
  top: ${({headerArenasStyleIsMenu}) => headerArenasStyleIsMenu ? "0.2rem" : 0};
  right: ${({headerArenasStyleIsMenu}) => headerArenasStyleIsMenu ? "0.6rem" : 0};
  padding: 0 0.5rem;
  background: ${({theme}) => theme.components.header.colors.indicatorBadge.backgroundInGridLayout.toString()};
  color: ${({theme}) => theme.colors.textLight.toString()};
  border-radius: 2rem;
  font-size: 0.9em;
  font-weight: 700;
  transform: translate(100%, -50%);
`;

export const HomepageHeaderArenaBadgeDefaultBox = DefaultBox;
